export const templatesKeys = {
  all: ['templates'] as const,
  categories: (locale: string | undefined) =>
    [...templatesKeys.all, 'categories', { locale }] as const,
  list: (url: string) => [...templatesKeys.all, 'list', { url }] as const,
}
